import router from '@/router'
import store from '@/store'

/**
 * 通用方法定义
 */

// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields()
  }
}
// 给表格的下拉框赋值(字典)
export function getTableDictValue(dictValue, tableValue) {
  for (let i = 0; i < dictValue.length; i++) {
    if (dictValue[i].value === tableValue) {
      return dictValue[i].name
    }
  }
}

// 给表格用户赋值
export function getUserName(userList, id) {
  for (let i = 0; i < userList.length; i++) {
    if (userList[i].id === id) {
      return userList[i].name
    }
  }
}

// 给表格部门赋值
export function getDeptName(deptList, id) {
  for (let i = 0; i < deptList.length; i++) {
    if (deptList[i].id === id) {
      return deptList[i].name
    } else if (deptList[i].children) {
      let result = getDeptName(deptList[i].children, id)
      if (result) {
        return result
      }
    }

  }
}

//打开菜单
export function openMenu(url, params) {
  if (params) {
    let routerParams = store.getters.getUser.routerParams
    if (!routerParams) {
      routerParams = {}
    }
    routerParams[url] = params
    store.dispatch('asyncUpdateRouterParams', routerParams)
  }
  router.push({ path: url, query: params })
}
